import { render, staticRenderFns } from "./getcode.vue?vue&type=template&id=50ec2cf9"
import script from "./getcode.vue?vue&type=script&lang=js"
export * from "./getcode.vue?vue&type=script&lang=js"
import style0 from "./getcode.vue?vue&type=style&index=0&id=50ec2cf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports